import { useEffect } from 'react';

import { useStore } from '@/store/useStore';
import { reinitAccountUmSession } from '@/unified-modules/account/useAccountUm';
import { PRODUCTS } from '@/utilities/constants/game';
import { usePopup } from '@/features/Popup/usePopup';

const KEEPALIVE_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Poker session refresh: keep-alive + silent session re-fetch on tab visible
 * and on a 5-minute interval (casino-next usePokerSessionRefresh parity).
 */
export const usePokerKeepAlive = () => {
  const { hidePopup } = usePopup();
  const product = useStore((s) => s.runtime.product);

  useEffect(() => {
    if (product?.toLowerCase() !== PRODUCTS.POKER) return;

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        void reinitAccountUmSession('visibility', hidePopup);
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange);

    const intervalId = window.setInterval(() => {
      void reinitAccountUmSession('interval', hidePopup);
    }, KEEPALIVE_INTERVAL_MS);

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      window.clearInterval(intervalId);
    };
  }, [product]);
};
